export const CATEGORIAS_LOADING = 'CATEGORIAS_LOADING';
export const CATEGORIAS_DATA = 'CATEGORIAS_DATA';
export const CATEGORIA_DATA = 'CATEGORIA_DATA';
export const CATEGORIAS_DISPONIVEIS_PARCEIRO = 'CATEGORIAS_DISPONIVEIS_PARCEIRO';

export const CATEGORIAS_DATA_PAGE = "CATEGORIAS_DATA_PAGE";
export const CATEGORIAS_DATA_PER_PAGE = "CATEGORIAS_DATA_PER_PAGE";
export const CATEGORIAS_DATA_TOTAL = "CATEGORIAS_DATA_TOTAL";